// Name3
import React, { useState, useEffect, useRef, useCallback } from "react"
import { Row, Col, message, Button, jsonToQueryString, useCRUDController, Spin, getClassifyStructureTypeDataLanguage, transformFormColumnDataToFiveWData, transformFiveWDataToFormColumnData, transformFormColumnDataToResponseFormValueData, TempDataProvider } from './ot'
import { useTranslation } from 'react-i18next'
import BaseInfoBlock from '../crm_base/base_info_block'
import BaseCanvasEdit from './base_canvas_edit'
import { useNavigate, useSearchParams } from "react-router-dom";
import Base5wCard from "./base_5w_card";
import { getStepCountFromValues, buildNodes, buildLines, createFormColumns, fillFormResponseData } from "./base_canvas_element_utils";
import axios from "axios" // NEW: needed for upload
// 有沒有id是用來判斷，新增功能還是編輯功能
const Name3 = ({
    propsCategoryName = '住戶',
    propsCategoryTitle = '欄位資料',
    componentDefinitionsAPIRoute = "/utility/component_definitions",
    componentDefinitionsApiRoute = null,
    componentAttributesAPIRoute = "/utility/component_attributes",
    componentAttributesApiRoute = null,
    selectionAPIRoute = '/utility/selection', // 拿下拉選的 route
    selectionApiRoute = null, // 拿下拉選的 route 更名
    dbCoverIdName = 'document_id', // 用來判斷編輯或新增的 id name
    mainAPIRoute = '/utility/document/base_view',//新增修改的 api
    mainApiRoute = null,//新增修改的 api 更名
    formColumnApiRoute = '/process_management/backend/process_document/form/form_column',//新增修改的 api 更名
    responseApiRoute = "/utility/response/cache",// 回覆 api
    pageFrontendRoute = '/utility/document/_3', //前端路徑，編輯完成重整用
    showTabkey = ["properties", "ai"],//["properties", "ai", "setting_tool" ,"step_setting"] 
    showComponent = ['BaseInfoBlock', 'BaseCanvasEdit'], //要顯示的元件
    testFrontendRoute = '/utility/form_static_5',
    card_header_showAIButton = true,
    dropDownDocumentAPiRoute,
    sourceDocumentApiRoute = "/utility/document/source",//新增修改的 api 更名
    keyPrefix = "/ad_plan/report/_3",
    documentFiveWAPI = "/utility/document/base_view",
    documentAPI = "/utility/document/base_view",
    fiveWResponseAPI = "/utility/response/cache", //5W 回覆 api
    five_w_id, // 五項 5W 請求的 ID 戰情室使用，去判斷要拿哪些documnent 資料
    toolBarRender = () => { return [] }, // 流程戰情室工具列渲染函式
    /**
     * processs-006 1. 2.
     * 1.加上propsProcess預設是false
     */
    propsProcess = false,
    thumbnailUploadAPIRoute = "/component/file" // NEW: upload endpoint for thumbnail
}) => {
    const finalSelectionApiRoute = selectionApiRoute ?? selectionAPIRoute
    const finalMainApiRoute = mainApiRoute ?? mainAPIRoute
    const finalComponentDefinitionsApiRoute = componentDefinitionsApiRoute ?? componentDefinitionsAPIRoute
    const finalComponentAttributesApiRoute = componentAttributesApiRoute ?? componentAttributesAPIRoute
    const { t } = useTranslation("translation", { keyPrefix })
    const [searchParams] = useSearchParams()
    const navigate = useNavigate()
    const dbCoverId = searchParams?.get(dbCoverIdName)
    const [loading, setLoading] = useState(false);
    const [createloading, setCreateLoading] = useState(false);
    const [selectionData, setSelectionData] = useState([]); //新的下拉選單組
    const [apiData, setApiData] = useState(null); // 存 API 回傳資料

    const [data, setData] = useState([]);
    const [frame, setFrame] = useState([]);
    const [frameCategorySelectionOption, setFrameCategorySelectionOption] = useState([]);
    const [contentInfo, setContentInfo] = useState({});
    const [canvasElement, setCanvasElement] = useState([]); //可以定義為defaultCanvasElement的值
    const [tempCanvasElement, setTempCanvasElement] = useState([]); //可以定義為CanvasElement的緩存結果
    const [formSubmitCheck, setFormSubmitCheck] = useState(false);
    const [AIGenerateData, setAIGenerateData] = useState({});
    const [fiveWData, setFiveWData] = useState([]);
    const [fiveWDataTemp, setFiveWDataTemp] = useState([]);
    const [dataCount, setDataCount] = useState(0);
    const externalFrameId = searchParams?.get('frame_id')

    const [documentIdInSource, setDocumentIdInSource] = useState(null);
    const [documentId, setDocumentId] = useState(null);
    const [fiveWResponseData, setFiveWResponseData] = useState([]) // 5W回覆資料，Base5wCard 使用
    const [thumbnailBlob, setThumbnailBlob] = useState(null)
    const canvasRef = useRef(null)
    const thumbnailFileId = useRef(null)
    //
    function transformToDocumentSelectionOptions({ selectionData, chosenValues }) {
        const optionMap = new Map();
        (selectionData || []).forEach(block => {
            (block.selection_selection_option_data || []).forEach(opt => {
                optionMap.set(opt.selection_option_id, opt);
            });
        });

        const pickedIds = [];
        Object.values(chosenValues || {}).forEach(arr => {
            if (!Array.isArray(arr)) return; // 🚀 避免 title / description 等非陣列
            arr.forEach(item => {
                if (item && typeof item.value === "number") {
                    pickedIds.push(item.value);
                }
            });
        });

        const seen = new Set();
        const uniquePickedIds = pickedIds.filter(id => {
            if (seen.has(id)) return false;
            seen.add(id);
            return true;
        });

        return uniquePickedIds.map(selection_option_id => {
            const src = optionMap.get(selection_option_id);
            if (!src) return null;
            const deepCopy = v => (v == null ? v : JSON.parse(JSON.stringify(v)));
            return {
                classify_structure_type_id: src.classify_structure_type_id ?? null,
                classify_structure_type_parent_id: src.classify_structure_type_parent_id ?? null,
                classify_structure_type_depth_id: src.classify_structure_type_depth_id ?? null,
                depth: src.depth ?? null,
                property_json: src.property_json != null ? deepCopy(src.property_json) : null,
                all_classify_structure_type_data: deepCopy(src.all_classify_structure_type_data) || [],
                title: src.title ?? null,
                name: src.name ?? null,
                name_language_data: deepCopy(src.name_language_data) || [],
                classify_structure_type_depth_data: deepCopy(src.classify_structure_type_depth_data) || [],
                children: src.children != null ? deepCopy(src.children) : null,
                selection_option_classify_structure_type_data:
                    deepCopy(src.selection_option_classify_structure_type_data) || [],
                selection_option_id
            };
        }).filter(Boolean);
    }
    function transformToChosenValues({ selectionData, outData }) {
        // 先建立 selection_option_id -> 父 selection 的 mapping
        const optionToSelectionMap = new Map();
        (selectionData || []).forEach(block => {
            (block.selection_selection_option_data || []).forEach(opt => {
                optionToSelectionMap.set(opt.selection_option_id, block.label);
            });
        });

        // 組裝 chosenValues
        const chosenValues = {};
        (outData || []).forEach(item => {
            const label = optionToSelectionMap.get(item.selection_option_id);
            if (!label) return; // 如果找不到來源就跳過

            if (!chosenValues[label]) {
                chosenValues[label] = [];
            }

            chosenValues[label].push({ value: item.selection_option_id });
        });

        return chosenValues;
    }

    //拿下拉選單資料
    const getSelectionData = () => {
        // 取得下拉選單資料
        SelectionController.getData()
            .then((res) => {
                // let data = res?.data || []
                let data = res?.data || []
                let selectionDataTemp = data?.map(item => {
                    let selection_classify_structure_type_data = item?.selection_classify_structure_type_data || []
                    let selection_classify_structure_type_data_first = selection_classify_structure_type_data?.find((_) => true)

                    //選項資料 selection_option_id、title
                    let selection_selection_option_data = (selection_classify_structure_type_data_first?.selection_selection_option_data || []).map((option) => {
                        let selection_option_classify_structure_type_data = option?.selection_option_classify_structure_type_data || []
                        let selection_option_classify_structure_type_data_first = selection_option_classify_structure_type_data?.find((_) => true)

                        return {
                            ...option,
                            label: option?.title,
                            name: option?.title,
                            description: selection_option_classify_structure_type_data_first?.selection_option_description || "",
                            value: selection_option_classify_structure_type_data_first?.value || selection_option_classify_structure_type_data_first?.selection_option_id,
                        }
                    })
                    return {
                        // 選單設定
                        label: item?.title || "",
                        label_icon: selection_classify_structure_type_data_first?.selection_icon,
                        placeholder: selection_classify_structure_type_data_first?.selection_placeholder,
                        selection_id: item?.selection_id,
                        component_type: "MULTISELECT",  //強制多選
                        name: item?.name,
                        // 選項設定
                        // component_type: selection_classify_structure_type_data_first?.component_type,
                        ...selection_classify_structure_type_data_first,
                        selection_selection_option_data
                    }
                }) || []
                setSelectionData(selectionDataTemp)



            })
            .catch((error) => {
                // 處理錯誤
            });
    }
    const onFrameCanvasSave = (values) => {
        let patchData = [
            {
                ...data,
                ...values,
                document_name: values?.title,
                document_category: values?.category,
                document_description: values?.document_description,
                // document_classify_structure_type_data: data?.document_classify_structure_type_data?.map((item) => {
                //     return {
                //         ...item,
                //         name_language_data: item?.name_language_data?.map((name) => {
                //             return {
                //                 ...name,
                //                 language_culture_value: values?.title
                //             }
                //         })
                //     }
                // }),
                document_classify_structure_type_data: [
                    {
                        document_classify_structure_type_id: data?.document_classify_structure_type_id,
                        classify_structure_type_id: data?.classify_structure_type_id,
                        classify_structure_type_name: data?.name,
                        name_language_data: data?.document_name_language_data
                    }
                ]
            }
        ]
        console.log({ patchData })
        MainApiController.patchData(patchData)
    }
    //mainDocument 5w 的回覆新增或是編輯
    const onMainDocument5WSubmit = ({ response_id, document_id, form_column_data, document_response_data }) => {
        let postValue = {
            "type": "1",
            "document_response_data": [
                {
                    "document_id": document_id
                }
            ],
            "response_form_value_data": [
                // {
                //     "form_column_form_value_data": [
                //         {
                //             "form_column_id": 1
                //         }
                //     ],
                //     "is_option": 1,
                //     "index": 2,
                //     "value": {
                //         "value": [1, 2, 3]
                //     },
                //     "value_type": "selection"
                // }
            ]
        }
        let response_form_value_data = transformFormColumnDataToResponseFormValueData(form_column_data);
        postValue = { ...postValue, response_form_value_data }
        let postData = [
            { ...postValue }
        ]

        let patchValue = {
            "type": 1,
            "response_id": response_id,
            "document_response_data": document_response_data,
            "response_form_value_data": response_form_value_data
        }
        let patchData = [
            {
                ...patchValue
            }
        ]
        if (response_id) {
            responseController.patchData(patchData)
        }
        else {
            responseController.postData(postData)
        }
    }
    const handleCaptureThumbnail = useCallback(async () => {
        try {
            if (!canvasRef.current?.captureThumbnail) {
                message.warning(t('縮圖功能不可用'))
                return null
            }

            const result = await canvasRef.current.captureThumbnail()

            let blob = null
            if (result instanceof Blob) {
                blob = result
            } else if (typeof result === 'string' && result.startsWith('data:')) {
                const res = await fetch(result)
                blob = await res.blob()
            }

            if (blob && blob.size > 0) {
                //  儲存取得縮圖 file_id
                const file = new File([blob], `${Date.now()}.png`, {
                    type: blob.type,
                    lastModified: Date.now(),
                });
                let form_data = new FormData();
                form_data.append("inputFile", file);

                // NEW: fixed upload logic
                const { data: uploadRes } = await axios.post(
                    `${thumbnailUploadAPIRoute}`,
                    form_data,
                    { headers: { "Content-Type": "multipart/form-data" } }
                );
                const uploadedFileId = uploadRes?.file_id != null ? parseInt(uploadRes?.file_id?.file_id) : null;
                console.log({ uploadedFileId });
                // TODO: use uploadedFileId if needed

                setThumbnailBlob(blob)
                thumbnailFileId.current = uploadedFileId
                return uploadedFileId
            }
            return null
        } catch (err) {
            console.error('縮圖錯誤:', err)
            message.error(t('取得縮圖失敗'))
            return null
        }
    }, [t, thumbnailUploadAPIRoute])

    const handleDownloadThumbnail = useCallback(async () => {
        try {
            let blob = thumbnailBlob

            if (!blob) {
                blob = await handleCaptureThumbnail()
            }

            if (!blob || blob.size === 0) {
                message.warning(t('尚未取得縮圖，請稍後再試'))
                return
            }

            // 使用 FileSaver 或原生方式
            try {
                // 方法1: 使用 Object URL
                const url = URL.createObjectURL(blob)
                const a = document.createElement('a')
                a.href = url
                a.download = `canvas-thumbnail-${Date.now()}.png`
                a.style.position = 'fixed'
                a.style.left = '-9999px'
                document.body.appendChild(a)
                a.click()

                setTimeout(() => {
                    document.body.removeChild(a)
                    URL.revokeObjectURL(url)
                }, 100)

                message.success(t('下載成功'))
            } catch (downloadErr) {
                // 方法2: 備用方案 - 使用 FileReader 轉 base64
                console.log('嘗試備用下載方式...')
                const reader = new FileReader()
                reader.onloadend = () => {
                    const a = document.createElement('a')
                    a.href = reader.result
                    a.download = `canvas-thumbnail-${Date.now()}.png`
                    a.style.position = 'fixed'
                    a.style.left = '-9999px'
                    document.body.appendChild(a)
                    a.click()
                    setTimeout(() => document.body.removeChild(a), 100)
                    message.success(t('下載成功'))
                }
                reader.onerror = () => {
                    message.error(t('下載失敗'))
                }
                reader.readAsDataURL(blob)
            }
        } catch (err) {
            console.error('下載錯誤:', err)
            message.error(t('下載縮圖失敗'))
        }
    }, [thumbnailBlob, handleCaptureThumbnail, t])
    const onMainAPISubmit = () => {
        //判斷是新增還是編輯
        if (dbCoverId) {
            let is_form_column_needed = showTabkey.includes("setting_tool") || showTabkey.includes("step_setting")
            let defaultMainPatchData = { ...data }
            let document_classify_structure_type_data = defaultMainPatchData?.document_classify_structure_type_data || []
            let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((_) => true)

            let name_language_data = defaultMainPatchData?.name_language_data
            let name_language_data_first = name_language_data?.find((_) => true)
            name_language_data_first = {
                ...name_language_data_first,
                language_culture_value: contentInfo?.title
            }
            let document_x_canvas_content_data = document_classify_structure_type_data_first?.document_x_canvas_content_data
            let document_x_canvas_content_data_first = document_x_canvas_content_data?.find((_) => true)
            //確認 canvas_content 是不是要用form 填寫，有的話需要加入 form_column_needed:1
            let newTempCanvasElement = [...tempCanvasElement]
            if (is_form_column_needed) {
                newTempCanvasElement = newTempCanvasElement.map((value) => {
                    return {
                        ...value,
                        form_column_needed: 1
                    }
                })
            }
            // console.log({
            //     newTempCanvasElement
            // })
            //response api 
            let response_postData = []
            // console.log({
            //     fiveWDataTemp,
            //     form_column_data: transformFiveWDataToFormColumnData(fiveWDataTemp)
            // })
            //取得外層5w 所需要資訊，用來新增該回覆內容，開始
            let document_source_data = document_classify_structure_type_data_first?.document_source_data || []
            let document_source_data_first = document_source_data?.find((_) => true)
            let document_source_data_document_source_data = document_source_data_first?.document_source_data || []
            let document_source_data_document_source_data_first = document_source_data_document_source_data?.find((_) => true)
            let document_id = document_source_data_document_source_data_first?.document_id
            let document_response_data = document_source_data_first?.document_response_data || []
            let document_response_data_first = document_response_data?.find((_) => true)
            let response_id = document_response_data_first?.response_id
            if (document_id) {
                onMainDocument5WSubmit({
                    response_id: response_id,
                    document_id: document_id,
                    form_column_data: transformFiveWDataToFormColumnData(fiveWDataTemp),
                    document_response_data
                })
            }

            //取得外層5w 所需要資訊，用來新增該回覆內容，結束

            let new_document_x_canvas_content_data_value = {
                ...document_x_canvas_content_data_first,
                content: newTempCanvasElement
            }
            //取得內層5w 所需要資訊，用來新增該回覆內容，

            let all_response_data = []
            newTempCanvasElement?.find(_ => true)?.elements.forEach((element) => {
                let form_form_column_data_outside = element?.form_form_column_data
                let form_column_source_data = form_form_column_data_outside?.find((_) => true)?.form_column_source_data
                let form_column_source_data_document_source_data = form_column_source_data?.find((_) => true)?.document_source_data?.find((_) => true)?.document_source_data
                let document_form_data = form_column_source_data_document_source_data?.find((_) => true)?.document_form_data
                let form_form_column_data = document_form_data?.find((_) => true)?.form_form_column_data ?? []

                let document_response_data = form_column_source_data_document_source_data?.find(_ => true)?.document_response_data;
                // console.log({ form_column_source_data_document_source_data })
                let patchResponseValue = {
                    "type": 1,
                    "response_id": document_response_data?.find(_ => true)?.response_id,
                    "response_form_value_data": form_form_column_data.map((value) => {
                        let value_type = value?.form_column_component_definitions_data?.find((_) => true)?.component_type
                        const isOption = ["dropdown", "radio_button", "multi_select_list", "checkbox"].includes(value_type) ? 1 : 0;

                        return {
                            value: value?.value,
                            value_type: value_type,
                            is_option: isOption,
                            form_column_form_value_data: [
                                {
                                    form_column_id: value?.form_column_id
                                }
                            ]
                        }
                    })
                }
                all_response_data.push(patchResponseValue)
            })

            all_response_data = all_response_data.filter((ele) => !!ele?.response_id)
            const result = transformToDocumentSelectionOptions({
                selectionData: selectionData,
                chosenValues: frame,
                // documentId,
                // startId
            });
            let new_document_classify_structure_type_data_value = {
                ...document_classify_structure_type_data_first,
                document_category: contentInfo?.category,
                document_description: contentInfo?.document_description || "",
                document_x_canvas_content_data: new_document_x_canvas_content_data_value ? [new_document_x_canvas_content_data_value] : [],
                document_selection_option_data: result || []
            }
            console.log({
                thumbnailFileId :thumbnailFileId.current
            })
            if (!!thumbnailFileId.current) {
                new_document_classify_structure_type_data_value['document_file_data'] = [{
                    cover_image_file_id: thumbnailFileId.current
                }]
            }
            defaultMainPatchData = {
                ...defaultMainPatchData,
                document_name: contentInfo?.title,
                name: contentInfo?.title,
                title: contentInfo?.title,
                name_language_data: name_language_data_first ? [{ ...name_language_data_first, language_value: contentInfo?.title, language_culture_value: contentInfo?.title }] : [],
                document_classify_structure_type_data: new_document_classify_structure_type_data_value ? [{ ...new_document_classify_structure_type_data_value }] : []
            }
            //編輯
            let patchData = [{ ...defaultMainPatchData }]
            if (all_response_data.length > 0) {
                responseController.patchData(all_response_data)
            }
            MainApiController.patchData(patchData)
        }
        else {
            //新增
            let postData = []
            // MainApiController.postData(postData)
        }
    }
    const getData = (dbCoverId, selectionData) => {
        MainApiController.getData({
            [dbCoverIdName]: dbCoverId
        })
            .then((res) => {
                let data = res?.data
                let dataFirst = data?.find((_) => true)
                //記錄該document_id 
                setDocumentId(dataFirst?.document_id);
                let document_classify_structure_type_data = dataFirst?.document_classify_structure_type_data || []
                let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((_) => true)
                let document_x_canvas_content_data = document_classify_structure_type_data_first?.document_x_canvas_content_data || []
                let document_x_canvas_content_first = document_x_canvas_content_data?.find((_) => true)
                // 取得畫布內容和ID
                let canvas_content = document_x_canvas_content_first?.content || []
                let document_selection_option_data = document_classify_structure_type_data_first?.document_selection_option_data || []
                let contentInfo2 = transformToChosenValues({
                    selectionData,
                    outData: document_selection_option_data
                })
                let contentInfoTemp = {
                    title: dataFirst?.document_name,
                    // category:,
                    // number,
                    create_user_name: document_classify_structure_type_data_first?.create_user_name,
                    document_description: document_classify_structure_type_data_first?.document_description,
                    create_time: document_classify_structure_type_data_first?.create_time,
                    ...contentInfo2
                }
                //設定 5w data
                let document_source_data = document_classify_structure_type_data_first?.document_source_data || []
                let document_source_data_first = document_source_data?.find((_) => true)
                let document_source_data_document_source_data = document_source_data_first?.document_source_data || []
                let document_source_data_document_source_data_first = document_source_data_document_source_data?.find((_) => true)

                let documentIdInSourceTemp = document_source_data_document_source_data_first?.document_id
                setDocumentIdInSource(documentIdInSourceTemp)

                let document_form_data = document_source_data_document_source_data_first?.document_form_data || []
                let document_form_data_first = document_form_data?.find((_) => true)
                let form_form_column_data = document_form_data_first?.form_form_column_data || []
                let document_response_data = document_source_data_document_source_data_first?.document_response_data || []
                // 把已選擇資料放入
                let update_form_form_column_data = fillFormResponseData(form_form_column_data, document_response_data)
                let fiveWDataTemp = transformFormColumnDataToFiveWData(update_form_form_column_data)

                //設定 5w data
                setFiveWData(fiveWDataTemp)

                setCanvasElement(canvas_content)
                setContentInfo({ ...contentInfoTemp })
                setData(dataFirst)
            })
            .catch((error) => {
                // 處理錯誤
            });
    }
    const getSourceData = (documentIdInSourceTemp) => {
        SourceApiController.getData({
            document_id: documentIdInSourceTemp
        })
            .then((res) => {
                let data = res?.data
                let dataFirst = data?.find((_) => true)
                let document_source_data = dataFirst?.document_source_data || []
                let document_source_data_first = document_source_data?.find((_) => true)

                //設定 5w data
                let document_form_data = document_source_data_first?.document_form_data || []
                let document_form_data_first = document_form_data?.find((_) => true)
                let form_form_column_data = document_form_data_first?.form_form_column_data || []
                let document_response_data = document_source_data_first?.document_response_data || []
                // 把已選擇資料放入
                let update_form_form_column_data = fillFormResponseData(form_form_column_data, document_response_data)
                let fiveWDataTemp = transformFormColumnDataToFiveWData(update_form_form_column_data)

                //設定 5w data
                setFiveWData(fiveWDataTemp)
            })
            .catch((error) => {
                // 處理錯誤
            });
    }
    const updateCanvas = (setCanvasElement, nodes, lines) => {
        // Input: setCanvasElement (State Setter), nodes (Array), lines (Array)
        // Output: 更新後的畫布資料
        setCanvasElement((prev) => {
            let newPages = Array.isArray(prev) ? [...prev] : [];
            if (newPages.length === 0) {
                newPages = [{
                    id: `page-${Date.now()}`,
                    name: "流程頁",
                    elements: [],
                }];
            }
            newPages[0].elements = [
                ...newPages[0].elements.filter(el => !["start_node", "process_node", "end_node", "flow_line"].includes(el.type)),
                ...nodes,
                ...lines,
            ];
            return newPages;
        });
    }

    const handleAddStepsFrom5w = async (values) => {
        setCreateLoading(true);
        try {
            const stepCount = getStepCountFromValues(values);
            if (!stepCount) return;

            const fivewData = values?.five_w_data
            let nodes = buildNodes(stepCount, fivewData);
            const lines = buildLines(nodes);

            nodes = await createFormColumns(nodes, formColumnController);
            console.log({ nodes, lines });
            updateCanvas(setCanvasElement, nodes, lines);

        } finally {
            setCreateLoading(false);
        }
    };
    const getCanvasContentId = (data) => {
        let document_classify_structure_type_data = data?.document_classify_structure_type_data || []
        let document_classify_structure_type_data_first = document_classify_structure_type_data?.find((_) => true)
        let document_x_canvas_content_data = document_classify_structure_type_data_first?.document_x_canvas_content_data || []
        let document_x_canvas_content_first = document_x_canvas_content_data?.find((_) => true)
        return document_x_canvas_content_first?.canvas_content_id
    }

    const MainApiController =
        useCRUDController({
            onFinish: ({ axiosMode, status, values }) => {
                if (status === "success") {
                    if (axiosMode === "post") {
                        message.success(t('新增成功'))
                        navigate(`${pageFrontendRoute}?` + jsonToQueryString({ [dbCoverIdName]: values?.[dbCoverIdName] }))
                    } else if (axiosMode === "patch") {
                        message.success(t('修改成功'))
                        getData(dbCoverId)
                    }
                }
                else if (status === "error") {
                    if (axiosMode === "post") {
                        message.error(t('新增失敗'))
                    }
                    else if (axiosMode === "patch") {
                        message.error(t('修改失敗'))
                    }
                }
                setLoading(false)
            },
            onBefore: ({ axiosMode, status, values }) => {
                setLoading(true)
                setDocumentIdInSource(null)
            },
            apiRoute: finalMainApiRoute,
        });
    const SelectionController =
        useCRUDController({
            onFinish: () => { },
            onBefore: () => { },
            apiRoute: finalSelectionApiRoute,
        });
    const responseController =
        useCRUDController({
            onFinish: ({ axiosMode, status, values }) => {
                if (status === "success") {
                    if (axiosMode === "post") {

                    }
                }
                else if (status === "error") {
                    if (axiosMode === "post") {
                    }
                }
            },
            onBefore: () => { },
            apiRoute: responseApiRoute,
        });
    const formColumnController =
        useCRUDController({
            onFinish: ({ axiosMode, status, values }) => {
                if (status === "success") {
                    if (axiosMode === "post") {

                    }
                }
                else if (status === "error") {
                    if (axiosMode === "post") {

                    }
                }
            },
            onBefore: () => { },
            apiRoute: formColumnApiRoute,
        });
    const SourceApiController =
        useCRUDController({
            onFinish: ({ axiosMode, status, values }) => {
                if (status === "success") {
                    if (axiosMode === "post") {
                        message.success(t('新增成功'))
                    } else if (axiosMode === "patch") {
                        message.success(t('修改成功'))
                    }
                }
                else if (status === "error") {
                    if (axiosMode === "post") {
                        message.error(t('新增失敗'))
                    }
                    else if (axiosMode === "patch") {
                        message.error(t('修改失敗'))
                    }
                }
                setLoading(false)
            },
            onBefore: ({ axiosMode, status, values }) => {
                setLoading(true)
            },
            apiRoute: sourceDocumentApiRoute,
        });
    const DocumentController = useCRUDController({
        onFinish: ({ axiosMode, status, values }) => {
        },
        onBefore: ({ axiosMode, status, values }) => {
        },
        apiRoute: documentAPI,
    });
    // 拿全部 document 資料的 controller 目前在流程戰情室的綁定表單使用
    // 為每個 five_w_id 預先創建獨立的 controller
    const controller_five_w_2 = useCRUDController({ apiRoute: fiveWResponseAPI });
    const controller_five_w_3 = useCRUDController({ apiRoute: fiveWResponseAPI });
    const controller_five_w_4 = useCRUDController({ apiRoute: fiveWResponseAPI });
    const controller_five_w_5 = useCRUDController({ apiRoute: fiveWResponseAPI });
    const controller_five_w_6 = useCRUDController({ apiRoute: fiveWResponseAPI });

    // 創建 controller 映射表
    const controllerMap = {
        2: controller_five_w_2,
        3: controller_five_w_3,
        4: controller_five_w_4,
        5: controller_five_w_5,
        6: controller_five_w_6
    };

    // 定義 five_w_array 在組件外部（或在 useEffect 內部但不在 if 條件中）
    const fetchFiveWData = async () => {
        const five_w_array = [
            { five_w_id: 2, name: "人" },
            { five_w_id: 3, name: "事" },
            { five_w_id: 4, name: "時" },
            { five_w_id: 5, name: "地" },
            { five_w_id: 6, name: "物" }
        ];

        // console.log('開始獲取 5W 資料，共 ' + five_w_array.length + ' 項', { five_w_array, propsProcess });

        try {
            // 使用 Promise.all 並發調用所有 5W 項目的資料
            const results = await Promise.all(
                five_w_array.map(item => {
                    // 使用預先創建的 controller
                    const controllerForThisId = controllerMap[item.five_w_id];

                    return controllerForThisId.getData({
                        five_w_id: item.five_w_id,
                        only_name: 1
                    })
                        .then(res => {
                            // console.log(`成功獲取 ${item.name}(ID: ${item.five_w_id}) 資料:`, res?.data);
                            return {
                                five_w_id: item.five_w_id,
                                five_w_name: item.name,
                                response_data: res?.data || []
                            };
                        })
                        .catch(error => {
                            // console.error(`失敗獲取 ${item.name}(ID: ${item.five_w_id}) 資料:`, error);
                            return {
                                five_w_id: item.five_w_id,
                                five_w_name: item.name,
                                response_data: [],
                                error: error.message
                            };
                        });
                })
            );
            // 設定到 state 供後續使用
            setFiveWResponseData(results);
        } catch (error) {
            console.error('Error fetching 5W data:', error);
        }
    };

    useEffect(() => {
        // getSelectionData()
        //取得下拉選單資料
        /**
         * processs-006 1. 2.
         * 1.判斷propsProcess是true
         * 2.表單的document
         * 3.response篩選five_w_id（等後端）
         */
        if (!!propsProcess) {
            fetchFiveWData();
            DocumentController.getData({
                base_on_classify_structure: 1
            })
        }
    }, [propsProcess])

    //新的串接資料格式
    useEffect(() => {
        if (dbCoverId) {
            // console.log({tempCanvasElement})
            if (dbCoverId) {
                getData(dbCoverId, selectionData)
            }
            else {
                setCanvasElement(defaultCanvasElement?.content || []);
            }
        }
    }, [dbCoverId, selectionData])
    useEffect(() => {
        // console.log({ tempCanvasElement })
    }, [tempCanvasElement])
    useEffect(() => {
        if (documentIdInSource) {
            getSourceData(documentIdInSource)
        }
    }, [documentIdInSource])



    return (
        <Spin size={40} spinning={loading}>
            <Row gutter={[0, 16]}>
                {showComponent.includes("BaseInfoBlock") && (
                    <Col span={24}>
                        <BaseInfoBlock
                            title={propsCategoryName + propsCategoryTitle + t('基本資訊')}
                            description={t('設定') + propsCategoryName + propsCategoryTitle + t('的基本資訊，包括標題、分類和標籤')}
                            fieldConfigs1={[
                                {
                                    name: "title",
                                    label: propsCategoryTitle + t('標題'),
                                    label_icon: "",
                                    label_css: "block text-sm font-medium text-gray-700 mb-1",
                                    component: <></>,
                                    component_type: "INPUT",
                                    placeholder: t('請輸入...'),
                                    badge: false,
                                    badge_name: "",
                                    label_content: "",
                                    property_option_json: [],
                                    selection_selection_option_data: [],
                                    order: 0,
                                    disabled: false,
                                    hidden: false,
                                    value: "test",
                                },
                                {
                                    name: "category",
                                    label: `${propsCategoryTitle}分類`,
                                    label_icon: "",
                                    label_css: "block text-sm font-medium text-gray-700 mb-1",
                                    component: <></>,
                                    component_type: "SELECT",
                                    placeholder: t('選擇分類'),
                                    badge: false,
                                    badge_name: "",
                                    label_content: "",
                                    property_option_json: frameCategorySelectionOption,
                                    selection_selection_option_data: frameCategorySelectionOption,
                                    order: 2,
                                    disabled: false,
                                    hidden: false,
                                },
                                {
                                    name: "number",
                                    label: `${propsCategoryTitle}編號`,
                                    label_icon: "",
                                    label_css: "block text-sm font-medium text-gray-700 mb-1",
                                    component: <></>,
                                    component_type: "INPUT",
                                    placeholder: t('請輸入...'),
                                    badge: false,
                                    badge_name: "",
                                    label_content: "",
                                    property_option_json: [],
                                    selection_selection_option_data: [],
                                    disabled: true,
                                    hidden: false,
                                },
                                {
                                    name: "create_user_name",
                                    label: t('建立人員'),
                                    label_icon: "<User />",
                                    label_css: "block text-sm font-medium text-gray-700 mb-1",
                                    component: <></>,
                                    component_type: "INPUT",
                                    placeholder: "請輸入...",
                                    badge: false,
                                    badge_name: "",
                                    label_content: "",
                                    property_option_json: [],
                                    selection_selection_option_data: [],
                                    order: null,
                                    disabled: true,
                                    hidden: false,
                                },
                                {
                                    name: "create_time",
                                    label: t('建立時間'),
                                    label_icon: "<Clock />",
                                    label_css: "block text-sm font-medium text-gray-700 mb-1",
                                    component: <></>,
                                    component_type: "INPUT",
                                    placeholder: "請選擇時間...",
                                    badge: false,
                                    badge_name: "",
                                    label_content: "",
                                    property_option_json: [],
                                    selection_selection_option_data: [],
                                    order: "",
                                    disabled: true,
                                    hidden: false,
                                },
                                {
                                    name: "status",
                                    label: propsCategoryName + t('狀態'),
                                    label_icon: "<FileCheck />",
                                    label_css: "block text-sm font-medium text-gray-700 mb-1",
                                    component: <></>,
                                    component_type: "LABEL",
                                    placeholder: "請輸入...",
                                    badge: true,
                                    badge_name: t('草稿'),
                                    label_content: t('版本 1.0'),
                                    property_option_json: [],
                                    selection_selection_option_data: [],
                                    order: 1,
                                    disabled: false,
                                    hidden: true,
                                },
                            ]}
                            // fieldConfigs2={frameSelection}
                            fieldConfigs2={selectionData}
                            fieldConfigs3={[
                                {
                                    name: "document_description",
                                    label: `${propsCategoryTitle}描述`,
                                    label_icon: "",
                                    label_css: "block text-sm font-medium text-gray-700 mb-1",
                                    component: <></>,
                                    component_type: "TEXTAREA",
                                    placeholder: t('請輸入') + propsCategoryName + propsCategoryTitle + t('的詳細描述，包括資料收集目的、使用範圍和管理規範等'),
                                    badge: false,
                                    badge_name: "",
                                    label_content: "",
                                    property_option_json: [],
                                    selection_selection_option_data: [],
                                    order: 0,
                                    disabled: false,
                                    hidden: false,
                                },
                            ]}
                            fieldValues={contentInfo}
                            formSubmitCheck={formSubmitCheck}
                            onDataChange={(values) => {
                                setFrame(values)
                                setContentInfo(values)
                            }}
                            onFinish={(check, values) => {
                                if (check) {
                                    // 先過濾出你要的欄位（名稱包含 frame_selection-004）
                                    let form_values = []
                                    Object.entries(values)
                                        .filter(([key]) =>
                                            key.startsWith('custom_page_layout_and_file_management-frame_selection-')
                                        )
                                        .map(([_, val]) => {
                                            form_values = [...form_values, ...val]
                                        }); // 只要值（value）

                                    form_values = form_values.map((val) => {
                                        let frame_frame_selection_option_id = val?.id
                                        let frame_selection_option_id = val?.value
                                        let newVal = {
                                            frame_id: Number(externalFrameId)
                                        }
                                        if (!!frame_frame_selection_option_id) newVal = { ...newVal, frame_frame_selection_option_id: frame_frame_selection_option_id }
                                        if (!!frame_selection_option_id) newVal = { ...newVal, frame_selection_option_id: frame_selection_option_id }
                                        return {
                                            ...newVal,
                                        }
                                    })
                                    onFrameCanvasSave({
                                        ...values,
                                        frame_frame_selection_option_data: form_values
                                    })
                                    setFormSubmitCheck(false)
                                }
                            }}
                        />
                    </Col>)}
                {showComponent.includes("Base5wCard") && (
                    <Col span={24}>
                        <Row>
                            <Col span={24}>
                                <TempDataProvider >
                                    <Base5wCard
                                        propsFiveWData={fiveWData}
                                        cardsPerRow={5}
                                        dataCount={dataCount}
                                        onFormFinish={(values) => {
                                            handleAddStepsFrom5w(values)
                                        }}
                                        onChange={(value) => {
                                            setFiveWDataTemp(value?.five_w_data || [])
                                        }}
                                        fiveWResponseData={fiveWResponseData}
                                        allDocumentData={DocumentController?.ResponseData || []}
                                    // fivewApi='/process_management/backend/process_5w'
                                    // dbCoverIdName='process_document_id'
                                    // propsDbCoverId  // 目前文件的 id
                                    />
                                </TempDataProvider>
                            </Col>
                            <Col span={24}>
                                <Row justify="center">
                                    <Col>
                                        <Button
                                            loading={createloading}
                                            type="default"
                                            size="large"
                                            onClick={() => {
                                                setDataCount(dataCount + 1)
                                            }}>
                                            {t('一鍵產生流程')}
                                        </Button>
                                    </Col>
                                    {/* <Col>
                                        <Button
                                            style={{ marginLeft: 8 }}
                                            type="default"
                                            size="large"
                                            onClick={handleDownloadThumbnail}>
                                            {t('下載縮圖')}
                                        </Button>
                                    </Col> */}
                                </Row>
                            </Col>
                        </Row>
                    </Col>
                )}
                <Col span={24}>
                    <BaseCanvasEdit
                        ref={canvasRef}
                        onCaptureThumbnail={setThumbnailBlob}
                        formColumnApiRoute={formColumnApiRoute}
                        base_on_classify_structure={true}
                        componentDefinitionsAPIRoute={finalComponentDefinitionsApiRoute}
                        componentAttributesAPIRoute={finalComponentAttributesApiRoute}
                        showTabkey={showTabkey}
                        propsLoading={null}
                        propsCanvasElement={canvasElement}
                        canvas_content_id={getCanvasContentId(data)}
                        onSave={async (values) => {
                            await handleCaptureThumbnail()
                            onMainAPISubmit()
                        }}
                        aiGenerateAPIRoute={"/utility/ai_produce"}

                        // Card header props
                        card_header_title={t('編輯') + propsCategoryTitle}
                        card_header_description={t('使用畫布編輯器拖放元件來創建您的欄位')}
                        card_header_icon={true}
                        card_header_className={"border-green-200 dark:border-green-800 bg-gradient-to-br from-green-50 to-transparent dark:from-green-950/30 dark:to-transparent"}
                        card_header_showSaveButton={true}
                        card_header_showAIButton={card_header_showAIButton}
                        card_header_saveButtonName={t('儲存') + propsCategoryTitle}
                        card_header_aiButtonName={t('AI一鍵生成')}
                        card_header_styles={{}}
                        aiGenerateQuantityRecommendationsAPIRoute={"/utility/ai_produce/controller/quantity_recommendations"}

                        target={propsCategoryName}
                        propsSelectionOptions={AIGenerateData}
                        propsSetSelectionOptions={() => { }}
                        onChange={(value) => {
                            //隨時確保拿到最新的 canvasElement
                            setTempCanvasElement(value);

                        }}
                        tools={testFrontendRoute ? [
                            {
                                label: t('測試頁面'),
                                onClick: () => {
                                    if (!!propsProcess) {
                                        navigate(`${testFrontendRoute}?${dbCoverIdName}=${dbCoverId}`)
                                    }
                                    else {
                                        navigate(`${testFrontendRoute}?document_id=${documentId}`)
                                    }
                                }
                            }
                        ] : []}
                        dropDownDocumentAPiRoute={dropDownDocumentAPiRoute}
                        documentFiveWAPI={documentFiveWAPI}
                        fiveWResponseAPI={fiveWResponseAPI}
                        five_w_id={five_w_id}
                        toolBarRender={() => {
                            return [
                                ...toolBarRender()
                            ]
                        }}
                        fiveWResponseData={fiveWResponseData}
                        allDocumentData={DocumentController?.ResponseData || []}
                    /**
                     * processs-006 3.
                     * 3.5w card送
                     */
                    />
                </Col>
            </Row>
        </Spin>
    )
}
export default Name3
const defaultCanvasElement = {
    "content": [
        {
            "id": `page-${Date.now()}`,
            "name": "新增頁面",
            "form_id": 87,
            "elements": [
                {
                    "x": 21,
                    "y": 29,
                    "id": "title-1756711135147",
                    "type": "title",
                    "style": {
                        "display": "flex",
                        "fontSize": "24px",
                        "textAlign": "center",
                        "alignItems": "center",
                        "fontWeight": "bold",
                        "justifyContent": "center",
                        "backgroundColor": "#fff"
                    },
                    "width": 300,
                    "height": 60,
                    "content": "標題",
                    "component_definitions_id": 13
                },
                {
                    "x": 22,
                    "y": 120,
                    "id": "text-content-1756711176969",
                    "type": "text-content",
                    "style": {
                        "padding": "10px",
                        "fontSize": "16px",
                        "lineHeight": "1.5",
                        "backgroundColor": "#fff"
                    },
                    "width": 300,
                    "height": 60,
                    "content": "",
                    "form_form_column_data": [
                        {
                            "code": "姓名",
                            "help_text": "確認說明文字",
                            "is_required": "1",
                            "placeholder": "請輸入全名",
                            "default_value": "",
                            "form_column_validation_data": [
                                {
                                    "max_value": 999,
                                    "min_value": 0,
                                    "wrong_message": "錯誤訊息",
                                    "max_text_number": "10",
                                    "min_text_number": 0,
                                    "only_allow_chinese": 0,
                                    "only_allow_english": 0,
                                    "disable_special_character": "1",
                                    "validation_selection_option_data": [
                                        {
                                            "selection_option_classify_structure_type_data": [
                                                {
                                                    "name_language_data": [
                                                        {
                                                            "language_culture_code": "zh-tw"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "form_column_selection_option_data": [
                                        {
                                            "selection_option_classify_structure_type_data": [
                                                {
                                                    "name_language_data": [
                                                        {
                                                            "language_culture_code": "zh-tw"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "validation_classify_structure_type_data": [
                                        {
                                            "name_language_data": [
                                                {
                                                    "language_culture_code": "zh-tw",
                                                    "language_culture_value": ""
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "form_column_selection_option_data": []
                        }
                    ],
                    "component_definitions_id": 14
                },
                {
                    "x": 30,
                    "y": 350,
                    "id": "phone_input-1756711202049",
                    "type": "phone_input",
                    "style": {
                        "color": "#000",
                        "width": 200,
                        "cursor": "pointer",
                        "display": "flex",
                        "fontSize": "16px",
                        "alignItems": "center",
                        "fontWeight": "bold",
                        "justifyContent": "center",
                        "backgroundColor": "transparent"
                    },
                    "width": 300,
                    "height": 60,
                    "content": "",
                    "form_form_column_data": [
                        {
                            "code": "電話",
                            "is_required": "1",
                            "default_value": "0912345678",
                            "form_column_validation_data": [
                                {
                                    "max_value": 999,
                                    "min_value": 0,
                                    "max_text_number": 99,
                                    "min_text_number": 0,
                                    "only_allow_chinese": 0,
                                    "only_allow_english": 0,
                                    "disable_special_character": 0,
                                    "validation_selection_option_data": [
                                        {
                                            "selection_option_classify_structure_type_data": [
                                                {
                                                    "name_language_data": [
                                                        {
                                                            "language_culture_code": "zh-tw"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "form_column_selection_option_data": [
                                        {
                                            "selection_option_classify_structure_type_data": [
                                                {
                                                    "name_language_data": [
                                                        {
                                                            "language_culture_code": "zh-tw"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "validation_classify_structure_type_data": [
                                        {
                                            "name_language_data": [
                                                {
                                                    "language_culture_code": "zh-tw",
                                                    "language_culture_value": ""
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "form_column_selection_option_data": []
                        }
                    ],
                    "component_definitions_id": 91
                },
                {
                    "x": 31,
                    "y": 239,
                    "id": "multi_select_list-1756711322696",
                    "type": "multi_select_list",
                    "style": {
                        "color": "#000",
                        "width": 200,
                        "cursor": "pointer",
                        "display": "flex",
                        "fontSize": "16px",
                        "alignItems": "center",
                        "fontWeight": "bold",
                        "justifyContent": "center",
                        "backgroundColor": "transparent"
                    },
                    "width": 300,
                    "height": 60,
                    "content": "",
                    "form_form_column_data": [
                        {
                            "code": "出生國家",
                            "help_text": "說明文字",
                            "is_required": "1",
                            "placeholder": "請選擇出生國家",
                            "default_value": "台灣",
                            "form_column_validation_data": [
                                {
                                    "max_value": 999,
                                    "min_value": 0,
                                    "max_text_number": 99,
                                    "min_text_number": 0,
                                    "only_allow_chinese": "0",
                                    "only_allow_english": "0",
                                    "disable_special_character": 0,
                                    "validation_selection_option_data": [
                                        {
                                            "selection_option_classify_structure_type_data": [
                                                {
                                                    "name_language_data": [
                                                        {
                                                            "language_culture_code": "zh-tw"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "form_column_selection_option_data": [
                                        {
                                            "selection_option_classify_structure_type_data": [
                                                {
                                                    "name_language_data": [
                                                        {
                                                            "language_culture_code": "zh-tw"
                                                        }
                                                    ]
                                                }
                                            ]
                                        }
                                    ],
                                    "validation_classify_structure_type_data": [
                                        {
                                            "name_language_data": [
                                                {
                                                    "language_culture_code": "zh-tw",
                                                    "language_culture_value": ""
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ],
                            "form_column_selection_option_data": [
                                {
                                    "selection_option_classify_structure_type_data": [
                                        {
                                            "name_language_data": [
                                                {
                                                    "language_culture_code": "zh-tw",
                                                    "language_culture_value": "台灣"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "selection_option_classify_structure_type_data": [
                                        {
                                            "name_language_data": [
                                                {
                                                    "language_culture_code": "zh-tw",
                                                    "language_culture_value": "日本"
                                                }
                                            ]
                                        }
                                    ]
                                },
                                {
                                    "selection_option_classify_structure_type_data": [
                                        {
                                            "name_language_data": [
                                                {
                                                    "language_culture_code": "zh-tw",
                                                    "language_culture_value": "義大利"
                                                }
                                            ]
                                        }
                                    ]
                                }
                            ]
                        }
                    ],
                    "component_definitions_id": 88
                }
            ]
        }
    ],
    "canvas_content_id": 78
}

